import { Component, computed, inject, input } from '@angular/core';
import type { SafeHtml } from '@angular/platform-browser';
import { DomSanitizer } from '@angular/platform-browser';

import { JsonLdService } from 'src/services/json-ld/json-ld.service';

@Component({
    selector: 'website-json-ld',
    template: '',
    host: {
        '[innerHTML]': 'trustedHtml()',
    },
})
export class JsonLdComponent {
    private sanitizer = inject(DomSanitizer);
    private readonly jsonLdService = inject(JsonLdService);

    readonly json = input<unknown>();

    readonly trustedHtml = computed(() => this.getSafeHTML(this.json()));

    get jsonLD(): SafeHtml {
        return this.trustedHtml();
    }

    getSafeHTML(value: unknown): SafeHtml {
        const sanitized = value ? this.jsonLdService.sanitizeSchema(value) : value;
        const json = sanitized ? JSON.stringify(sanitized, null, 2).replace(/<\/script>/g, '<\\/script>') : '';
        const html = `<script type="application/ld+json">${json}</script>`;
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }
}
